import { render, staticRenderFns } from "./PersonView.vue?vue&type=template&id=ae9d707c&scoped=true"
import script from "./PersonView.vue?vue&type=script&lang=js"
export * from "./PersonView.vue?vue&type=script&lang=js"
import style0 from "./PersonView.vue?vue&type=style&index=0&id=ae9d707c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9d707c",
  null
  
)

export default component.exports